// extracted by mini-css-extract-plugin
export default {"text":"index_text_qvLXT"};